import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-hide',
	templateUrl: './icon-hide.component.svg',
})
export class IconHideComponent {}
